document.addEventListener('DOMContentLoaded', function () {
  console.log('bundle js loaded');

  const bundleDataEl = document.getElementById('bundle-product-data');
  console.log('bundleDataEl:', bundleDataEl);

  if (!bundleDataEl) return;

  const isBundle = String(bundleDataEl.dataset.isBundle) === 'true';
  console.log('isBundle:', isBundle, 'raw:', bundleDataEl.dataset.isBundle);

  if (!isBundle) return;

  const bundleButton = document.querySelector('[id^="BundleAddButton-"]');
  console.log('bundleButton found:', bundleButton);

  if (!bundleButton) {
    console.error('Bundle add button not found.');
    return;
  }

  let bundleItems = [];
  const rawBundleItems = bundleDataEl.dataset.bundleItems || '[]';
  console.log('rawBundleItems:', rawBundleItems);

  try {
    bundleItems = JSON.parse(rawBundleItems);
    console.log('parsed bundleItems:', bundleItems);
  } catch (err) {
    console.error('Bundle metafield JSON is invalid.', err);
    return;
  }

  if (!Array.isArray(bundleItems) || bundleItems.length === 0) {
    console.error('Bundle items array is empty.');
    return;
  }

  bundleButton.addEventListener('click', async function (event) {
    event.preventDefault();
    console.log('bundle button clicked');

    const items = bundleItems
      .filter(item => item.variant_id && item.quantity)
      .map(item => ({
        id: Number(item.variant_id),
        quantity: Number(item.quantity)
      }));

    console.log('items being sent to cart:', items);

    if (!items.length) {
      alert('Bundle configuration is invalid.');
      return;
    }

    bundleButton.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();
      console.log('Shopify response:', data);

      if (!response.ok) {
        console.error('Shopify cart error:', data);
        alert(data.description || 'Failed to add bundle to cart.');
        return;
      }

      window.location.href = '/cart';
    } catch (error) {
      console.error('Network or cart add error:', error);
      alert('Something went wrong while adding this bundle.');
    } finally {
      bundleButton.disabled = false;
    }
  });
});